import dayjs from "dayjs";
import { decryptSecretKey } from "./decrypt";

export const daysjsDateFormat =(dateAndTime)=>{
    const format = "MM/DD/YYYY";
    const Date =   dayjs(dateAndTime).format(format);
  
    return Date;
}
// login token 
export const userToken = () =>{
  const getToken = localStorage.getItem("portal_key");
  // const token = decryptSecretKey(getToken);
  const token = (getToken);

  return token;   
}

export function toUppercase(string) {
    const firstLetter = string?.charAt(0);
    const upperCaseFirstLetter = firstLetter?.toUpperCase();
    const restString = string?.slice(1);
    const upperCaseString = upperCaseFirstLetter + restString;

     return upperCaseString;
    
  }

//   product serialNo type format
  export function removeUnderScoreformatChange(formatType){

    const format = formatType.split("_").join(" ");
    const formatElement = format[0].toUpperCase() + format.substring(1).toLowerCase();
   
    return formatElement;
  }

//   format with comma for serial no view page
export function formatSerialNumbersWithCommas(serialNumbers) {
    // Add commas between the serial numbers, but not at the end of the number.
    const formattedSerialNumbers = serialNumbers?.map((serialNumber, index) => {
      if (index !== serialNumbers?.length - 1) {
        return serialNumber + ", ";
      }
      return serialNumber;
    });
    return formattedSerialNumbers;
  }

  export function toUppercaseWithConcat(first_str, second_str){
    const firstNameToUpperCase = first_str.charAt(0).toUpperCase() + first_str.slice(1);
    const lastNameToUpperCase = second_str.charAt(0).toUpperCase() + second_str.slice(1);
    const concatString = firstNameToUpperCase + " " + lastNameToUpperCase
   return concatString;
  }

  export function differenceBetweenNumber(serialNoFormatRegex, startingNumber, endingNumber){
    // const starting = "ABC21252556"
    // const ending = "ABC21252570"
    // const starting = "EDPM14B12589876"
    // const formatRegexs = "[EDPM]{1}[0-9A-Z]{8}\d{6}" 
    // const formatRegexs2 = "ABC21\d{6}"

    if(serialNoFormatRegex?.startsWith("[EDPM]")){
      const startConvertion = parseInt(startingNumber?.substring(7));
      const endConvertion = parseInt(endingNumber?.substring(7));
      const difference = endConvertion - startConvertion;
      return difference;
    }else if(serialNoFormatRegex?.startsWith("ABC21")){
      const startConvertion = parseInt(startingNumber?.substring(5));
      const endConvertion = parseInt(endingNumber?.substring(5));
      const difference = endConvertion - startConvertion;
      return difference;
    }
  }

  export function convertFormat_Imagename(prevImage){
    // const prevImage = "gallery_image_1699517054587_image_1695634583152_2021-Best-Quality-DP-for-Whatsapp-Profile-Images.jpeg"
     const firstStep = prevImage?.split("_")
     const secondStep = firstStep?.slice(3)
     const convertedFormat = secondStep?.join("_")

       return convertedFormat;
  }

  export function convertToArrayFormat(arrayOfObj){
    const serialNumbers = arrayOfObj?.map(obj => obj.serialNumber);
    return serialNumbers;
  }

  
  export function adminMemberData(){
   const user = {
    secretKey: localStorage.getItem("portal_key"),
    userName : localStorage.getItem("email")
   }
   return user;
  }

  export function adminUserId (){
    const userId = localStorage.getItem("adminUser_id");
    return userId
  }

  export function convertLowercase(string){
    const modified = string.split(" ").map(word => word.charAt(0).toLowerCase() + word.slice(1));
    const modifiedString = modified.join(" ");
    return modifiedString;
  }

  export function isPasswordMismatch(password, confirmPassword ){
    if(password && confirmPassword !== password && confirmPassword){
      return true
    }else{
      return false
    }
  }